module.exports = __webpack_public_path__ + "159a660b497126759b2b9a1d9e7f381a.jpg";